import Tool from './Tool';
import Shortcut from '../utils/Shortcut';

class ToolDeselect extends Tool {
  static toolName = 'Deselect';
  static shortcut = new Shortcut('Esc');

  static action({ controller }) {
    controller.actionFocus();
    controller.actionSetStylusMenu(null);
    controller.actionSetStylus(controller.stylusPointer);
    controller.actionHideContextMenu();
    controller.actionUnlockStylus();
    controller.canvas.discardActiveObject();
    controller.canvas.requestRenderAll();
  }

  static enabled() {
    return true;
  }
}

export default ToolDeselect;
